<nav class="navbar navbar-expand-md navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img src="assets/brand-dark.svg" height="30px" alt="Digital Oilfield AI" draggable="false" />
      <span class="d-none d-sm-inline ms-3">Digital Oilfield AI</span>
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" [class.show]="isOpen()">
      <ul class="navbar-nav w-100">
        @for (block of menu.blocks; track block.title) {
          <li class="nav-item" *ngxPermissionsOnly="block.permissions || 'any'" [class.dropdown]="block.children?.length" dropdown>
            @if (block.children?.length) {
              <a class="nav-link dropdown-toggle" dropdownToggle>
                {{ block.title }}
              </a>
              <ul class="dropdown-menu" *dropdownMenu>
                @for (child of block.children; track child) {
                  <li *ngxPermissionsOnly="child.permissions || 'any'">
                    <a class="dropdown-item" [routerLink]="child.link" [routerLinkActive]="'active'">
                      {{ child.title }}
                    </a>
                  </li>
                }
              </ul>
            } @else {
              <a class="nav-link" [routerLink]="block.link" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
                {{ block.title }}
              </a>
            }
          </li>
        }
        <li class="me-auto"></li>
        @if (isAuthenticated() && userFirstName(); as firstName) {
          <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link dropdown-toggle" dropdownToggle>
              <strong>{{ firstName }}</strong>
            </a>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-end" role="menu">
              <li>
                <button class="dropdown-item" (click)="logout()">
                  <fa-icon [icon]="logoutIcon" [fixedWidth]="true" />
                  <span class="ms-3">Logout</span>
                </button>
              </li>
            </ul>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link" (click)="toggleTheme()" href="javascript:void(0);">
            <fa-icon [icon]="themeIcon()" [fixedWidth]="true" />
            <span class="ms-3 d-sm-none">{{ themeText() }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
